var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop } from 'vue-property-decorator';
import { BButton } from 'bootstrap-vue';
import { addToCart } from 'ts/modules/cart';
let MouldingSampleAddToCart = class MouldingSampleAddToCart extends Vue {
    get displayPrice() {
        return this.vatMode == "ex" ? '0.50' : '0.60';
    }
    addToCart() {
        addToCart({
            sku: `SMPM-${this.sku}`,
            qty: 1,
            attributes: {},
            price: "0.50"
        }, false);
    }
};
__decorate([
    Prop(String)
], MouldingSampleAddToCart.prototype, "sku", void 0);
__decorate([
    Prop(String)
], MouldingSampleAddToCart.prototype, "vatMode", void 0);
MouldingSampleAddToCart = __decorate([
    Component({
        components: {
            BButton
        }
    })
], MouldingSampleAddToCart);
export default MouldingSampleAddToCart;
